// File Metadata:
// Filename: constants.js
// Version: 1.00
// Created: 2022-10-04 19:31:11
// Last Modified: 2025-04-01 16:55:19
// Authors: [Your Name]
// Description: A brief summary of what this file does

export const CONSTANT = {
	development: true,
	ik_pub_key: 'public_fU6mvf6J00V8268aP+56pFUIksM='
}

export const LOADERS = [
	{
		id: 0,
		name: '-- Unloaded By --'
	},
	{
		id: 2,
		name: 'Bjorn Callens'
	},
	{
		id: 3,
		name: 'Glenn Waneyn'
	},
	{
		id: 4,
		name: 'Nick Labaere'
	},
	{
		id: 5,
		name: 'Gianni Plaisier'
	},
	{
		id: 6,
		name: 'Tom Vanhee'
	},
	{
		id: 7,
		name: 'Dieuwer Descheemaecker'
	},
	{
		id: 8,
		name: 'Rachid'
	},
	{
		id: 9,
		name: 'Rafal Papiernik'
	},
	{
		id: 10,
		name: 'Navajo Casier'
	}
]

export const TYPES = {
	tasklog: [
		{
			taskId: 'inbound',
			text: 'Inbound HU'
		},
		{
			taskId: 'outbound',
			text: 'Outbound HU'
		},
		{
			taskId: 'picklist',
			text: 'Pick List'
		},
		{
			taskId: 'tour',
			text: 'TU (Truck)'
		},
		{
			taskId: 'stockerror',
			text: 'Stock Error'
		},
		{
			taskId: 'customtask',
			text: 'Custom Task'
		},
		{
			taskId: 'parcel',
			text: 'Parcel Delivery'
		}
	]
}

export const CROSSDOCK_REGEX = /^\/dash\/crossdock/
